module.exports = [
    {
        "question": "网络借贷风险提示",
        "answers": [
            "用户应当了解并认可，任何通过网贷平台进行的交易并不能避免以下风险的产生，网贷平台不能也没有义务为如下风险负责，用户应当在做出交易决策前，审慎阅读本风险提示，根据自身的交易目标、风险承受能力和资产状况等谨慎决策，并自行承担全部风险："
        ]
    },
    {
        "question": "（一）法律及监管风险",
        "answers": [
            "因财政政策、货币政策、产业政策、区域发展政策等国家宏观政策发生变化以及相关监管机构对法律法规及政策的官方解释和执行尺度也可能存在较大不确定性，可能会引发相应风险，从而可能对出借人的投资收益造成不利影响。"
        ]
    },
    {
        "question": "（二）信用风险",
        "answers": [
            "若借款人未能及时足额兑付本金及收益，包括借款人因收入情况、财产状况发生变化、人身出现意外、发生疾病、死亡等情况，短期或者长期丧失还款能力，或者借款人的还款意愿发生变化时，出借人的出借资金可能无法按时回收甚至无法回收，出借人的预期收益可能无法实现。借款人确认，网贷平台按照《网络借贷信息中介机构业务活动管理暂行办法》规定仅提供信息服务，并不对的出借人投资本金和任何预期收益承担保证、保本承诺或任何其他责任。"
        ]
    },
    {
        "question": "（三）流动性风险",
        "answers": [
            "针对出借人的出借本金，网贷平台会积极帮助出借人寻找、推荐借款人，但这一撮合匹配时间长短存在一定不确定性。同时，网贷平台在出借人提出债权转让需求时，会努力帮助出借人寻找、推荐愿意受让债权的其他出借人，以完成出借人的债权转让，但网贷平台并不能对债权转让的实现以及具体实现时间做出任何承诺和保证，可能导致出借人需要资金时不能随时变现，并可能使出借人丧失其他投资机会。"
        ]
    },
    {
        "question": "（四）利率风险",
        "answers": [
            "由于市场利率变化可能对出借人的实际收益产生影响。"
        ]
    },
    {
        "question": "（五）用户使用风险",
        "answers": [
            "因用户的过错导致的出借资金无法按时回收甚至无法回收，该过错包括但不限于：用户决策失误、操作不当、遗忘或泄露密码、用户使用的计算机系统被第三方侵入、用户委托他人代理交易时他人恶意或不当操作而造成的损失。"
        ]
    },
    {
        "question": "（六）不可抗力风险",
        "answers": [
            "由于网贷平台及相关第三方的设备、系统故障或缺陷、病毒、黑客攻击、网络故障、网络中断、地震、台风、水灾、海啸、雷电、火宅、瘟疫、流行病、战争、恐怖主义、敌对行为、暴动、罢工、交通中断、停止供应主要服务、电力中断、经济形势严重恶化或其它类似事件，导致出借人利益损失甚至本金损失风险。"
        ]
    }

]


// WEBPACK FOOTER //
// ./src/config/Edu/RiskEdu.js